import { Record, Resource, SDK } from '@redge-media/fo-js-sdk';
import { ProductType } from '@/shared/enums';

const PATHS = {
  [ProductType.VOD]: 'vods/:id',
  [ProductType.EPISODE]: 'vods/:id/serials',
  [ProductType.SERIAL]: 'vods/:id/serials',
  [ProductType.CLIP]: 'vods/:id/clips',
  [ProductType.PROGRAMME]: 'lives/programmes/:id',
  [ProductType.LIVE]: 'lives/:id',
  [ProductType.N_PVR]: 'lives/:id/programs/recordings',
};

const ProductRecommendations = Resource.extend({
  endpoint: '/products',
  constructor: function Recommendations(product = {}) {
    Resource.call(this);

    if (product.id == null) {
      throw new Error('product id is obligatory');
    }

    if (!product.type || !PATHS[product.type]) {
      throw new Error('product type is obligatory');
    }

    this.id = product.id;
    if (product.live) {
      this.id = product.live.id;
    }

    this.path = PATHS[product.type].replace(':id', this.id);
  },

  createRecord(props = {}, opts = {}) {
    if (props instanceof Record) {
      return props;
    }

    return SDK.factory.resolve(props, opts);
  },

  getPath() {
    return `${this.endpoint}/${this.path}/recommendations`;
  },
});

export default ProductRecommendations;
